import { createStore } from "vuex";
import Session from './modules/Session'
import Location from './modules/Location'
import InspirationalQuote from "./modules/InspirationalQuote";
import ChangePassword from "./modules/ChangePassword";
import RequestAssistance from "./modules/RequestAssistance";
import JoinOrganization from "./modules/JoinOrganization";
import Utilities from "./modules/Utilities";
import Calendar from "./modules/Calendar";
import Menu from "./modules/Menu";
import PendingRegistrations from "./modules/PendingRegistrations";
import MessagingUnit from "./modules/MessagingUnit";
import AutoEngine from "./modules/AutoEngine";
import MonthToDateUsage from "./modules/MonthToDateUsage";
import Activities from "./modules/Activities";
import Auth from "./modules/Auth";
import Skill from "./modules/Skills";
import VolunteerSignupForm from "./modules/VolunteerSignupForm";
import Logs from "./modules/Logs";
import Organizations from "./modules/Organizations";
import Users from "./modules/Users";
import PersonPreferences from "./modules/PersonPreferences";
import Availability from "./modules/Availability";
import preferredActivitiesAndWorkgroup from "./modules/PreferredActivitiesAndWorkgroup";
import availableWorkgroupTeam from "./modules/AvailableWorkgroupTeam";
import notificationPreferences from "./modules/NotificationPreferences";
import currentAssignedSkills from "./modules/CurrentAssignedSkills";
import interestSkills from "./modules/InterestSkills";
import personAssignments from "./modules/PersonAssignments";
import schedulePreferences from "./modules/SchedulePreferences";
import editSkill from "./modules/EditSkill";
import usersSummary from "./modules/UsersSummary";
import allSchedules from "./modules/AllSchedules";
import editActivity from "./modules/EditActivities";
import workgroups from "./modules/Workgroups";
import workgroupRecurrences from "./modules/WorkgroupRecurrences";
import activityInstances from "./modules/ActivityInstances";
import manageActivityUsers from "./modules/ManageActivityUsers";
import manageActivityAdmins from "./modules/ManageActivityAdmins";
import editWorkgroup from "./modules/EditWorkgroup";
import SkillVolunteerForWorkgroup from "./modules/SkillVolunteerForWorkgroup";
import WorkgroupInstance from "./modules/WorkgroupInstance";
import ManageWorkgroupAdmins from "./modules/ManageWorkgroupAdmins";
import WorkgroupPreference from "./modules/WorkgroupPreference";
import ScheduleByTeam from "./modules/ScheduleByTeam";
import Instance from "./modules/Instance";
import InstanceWorkgroup from "./modules/InstanceWorkgroup";
import ResetPassword from "./modules/ResetPassword";
import HelpText from "./modules/HelpText";
import Billing from "./modules/Billing";
import Ads from "./modules/Ads";
import Breadcrumb from "./modules/Breadcrumb";
import Ezer from "./modules/Ezer";
import VolunteerStats from "./modules/VolunteerStats";

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Session,
    Location,
    InspirationalQuote,
    ChangePassword,
    RequestAssistance,
    JoinOrganization,
    Utilities,
    Calendar,
    Menu,
    PendingRegistrations,
    MessagingUnit,
    AutoEngine,
    MonthToDateUsage,
    Activities,
    Auth,
    Skill,
    VolunteerSignupForm,
    Logs,
    Organizations,
    Users,
    PersonPreferences,
    Availability,
    preferredActivitiesAndWorkgroup,
    availableWorkgroupTeam,
    notificationPreferences,
    currentAssignedSkills,
    interestSkills,
    personAssignments,
    schedulePreferences,
    editSkill,
    usersSummary,
    allSchedules,
    editActivity,
    workgroups,
    workgroupRecurrences,
    activityInstances,
    manageActivityUsers,
    manageActivityAdmins,
    editWorkgroup,
    SkillVolunteerForWorkgroup,
    WorkgroupInstance,
    ManageWorkgroupAdmins,
    WorkgroupPreference,
    ScheduleByTeam,
    Instance,
    InstanceWorkgroup,
    ResetPassword,
    HelpText,
    Billing,
    Ads,
    Breadcrumb,
    Ezer,
    VolunteerStats
  }
})
